/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function TimecardStatsHideIcon({
  width = 11,
  height = 11,
  color = '#4A6B8D',
  className,
  style,
}) {
  return (
    <svg
      className={className}
      style={{
        width,
        height,
        flexShrink: 0,
        ...style,
      }}
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d="M1.65256 2.86296C1.17843 3.20145 0.794031 3.5634 0.499464 3.88241C-0.166489 4.60362 -0.166488 5.68142 0.499465 6.40263C1.36317 7.33799 2.99921 8.64252 5.40481 8.64252C6.05269 8.64252 6.64476 8.54789 7.18095 8.39134L6.34956 7.55996C6.05163 7.61299 5.73672 7.64252 5.40481 7.64252C3.38827 7.64252 1.99898 6.5525 1.23416 5.72422C0.921948 5.38611 0.921948 4.89892 1.23416 4.56081C1.52359 4.24736 1.90245 3.89644 2.37089 3.58128L1.65256 2.86296Z" fill={color} />
      <path d="M3.67131 4.88171C3.6586 4.9668 3.65201 5.05389 3.65201 5.14252C3.65201 6.10901 4.43551 6.89252 5.40201 6.89252C5.49064 6.89252 5.57773 6.88593 5.66282 6.87321L3.67131 4.88171Z" fill={color} />
      <path d="M7.13786 5.36606L5.17847 3.40666C5.25166 3.39733 5.32627 3.39252 5.40201 3.39252C6.36851 3.39252 7.15201 4.17602 7.15201 5.14252C7.15201 5.21825 7.1472 5.29286 7.13786 5.36606Z" fill={color} />
      <path d="M8.46071 6.6889C8.91904 6.3776 9.29057 6.03275 9.57547 5.72422C9.88767 5.38611 9.88767 4.89892 9.57546 4.56081C8.81065 3.73253 7.42136 2.64252 5.40481 2.64252C5.08452 2.64252 4.78005 2.67001 4.4914 2.71959L3.65723 1.88543C4.18587 1.73382 4.76841 1.64252 5.40481 1.64252C7.81041 1.64252 9.44646 2.94704 10.3102 3.88241C10.9761 4.60362 10.9761 5.68141 10.3102 6.40263C10.02 6.71681 9.64279 7.07264 9.17851 7.4067L8.46071 6.6889Z" fill={color} />
      <path d="M0.408759 0.853553C0.213497 0.658291 0.213498 0.341709 0.40876 0.146447C0.604022 -0.0488155 0.920604 -0.0488155 1.11587 0.146447L10.405 9.43561C10.6003 9.63087 10.6003 9.94746 10.405 10.1427C10.2098 10.338 9.89319 10.338 9.69792 10.1427L0.408759 0.853553Z" fill={color} />
    </svg>
  );
}

TimecardStatsHideIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};
